import styled from 'styled-components';

export const Page = styled.div`
  width: 98%;
  margin: auto;
  padding: 5px;
  padding-bottom: 100px;
  margin-bottom: 100px;
  .ant-col {
    padding: 0px 4px;
  }
`;

export const Card = styled.div`
  width: ${props => `calc(${props.width} - 40px)`};
  margin: 20px;
  border-radius: 10px;
  background-color: var(--bottom-color-sefaz);
  box-shadow: 0 2px 6px rgb(0 0 0 / 16%);
  padding: 20px;
  height: calc(100% - 40px);
`;

export const TitleCard = styled.p`
  margin: 0px;
  color: var(--primary-color-sefaz);
  font-size: 15pt;
  font-weight: 600;
`;

export const HeaderContain = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const ContainButton = styled.div`
  display: flex;
  align-self: flex-end;
  gap: 8px;
`;

export const ContainerButton = styled.div`
  display: flex;

  button {
    margin: 5px;
    height: 70px;
  }

  .ant-btn {
    background-color: transparent;
    color: var(--primary-color-sefaz);
    border-color: var(--primary-color-sefaz) 2px;

    &:hover {
      box-shadow: 0 2px 3px rgb(0 0 0 / 50%);
    }
  }
`;
